// ===================================================================
// AMANCARE FRONTEND - PRODUCTION ENVIRONMENT
// src/environments/environment.prod.ts
// ===================================================================

export const environment = {
  // ===================================================================
  // ENVIRONMENT TYPE
  // ===================================================================
  production: true,

  // ===================================================================
  // API CONFIGURATION - PRODUCTION
  // ===================================================================
  // ⚠️ Update this to your actual production API URL
  apiUrl: 'https://api.amancares.com/api/v1',

  // ===================================================================
  // APPLICATION INFO
  // ===================================================================
  appName: 'نظام أمان كير',
  appNameEn: 'Amancare System',
  version: '1.0.0',
  defaultLanguage: 'ar',

  // ===================================================================
  // STORAGE KEYS
  // ===================================================================
  tokenKey: 'amancare_token',
  refreshTokenKey: 'amancare_refresh_token',
  userKey: 'amancare_user',
  clinicKey: 'amancare_clinic',
  themeKey: 'amancare_theme',
  themePreferenceKey: 'amancare_theme_preference',

  // ===================================================================
  // SENTRY ERROR TRACKING - PRODUCTION
  // ===================================================================
  sentry: {
    dsn: 'https://12c69d1f96be27c171bcd3ca71f24d82@o4510397949018112.ingest.us.sentry.io/4510404952522752',
    environment: 'production',
    enabled: true, // ✅ ENABLED in production
    tracesSampleRate: 0.1, // 10% of transactions
    replaysSessionSampleRate: 0.1, // 10% of normal sessions
    replaysOnErrorSampleRate: 1.0, // 100% of error sessions
    beforeSend: true,
    debug: false,
  },

  // ===================================================================
  // UI CONFIGURATION
  // ===================================================================
  ui: {
    rtl: true,
    toastrTimeout: 3000, // Shorter in production
  },
};
